export default function Solution() {
  const solutions = [
    {
      number: '01',
      title: 'Visites terrain régulières',
      description: 'Inspections hebdomadaires avec documentation photographique complète de votre propriété.'
    },
    {
      number: '02',
      title: 'Maintenance préventive',
      description: 'Interventions planifiées pour éviter les dégradations et préserver la valeur de votre bien.'
    },
    {
      number: '03',
      title: 'Reporting mensuel clair',
      description: 'Rapports détaillés avec photos, vidéos et synthèse financière envoyés chaque mois.'
    },
    {
      number: '04',
      title: 'Processus rigoureux et traçables',
      description: 'Chaque intervention est documentée et suit nos standards de qualité française.'
    }
  ];

  return (
    <section id="solution" className="py-20 md:py-32 bg-[#1A3B5C] text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, #C9A961 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">Notre Réponse Terrain</h2>
          <div className="w-16 h-1 bg-[#C9A961] mx-auto"></div>
        </div>

        <div className="grid md:grid-cols-5 gap-8 items-start">
          <div className="md:col-span-2">
            <p className="text-lg md:text-xl leading-relaxed text-white/90">
              AMD Gestion Immobilière apporte une solution complète basée sur la{' '}
              <span className="text-[#C9A961] font-semibold">présence terrain</span>, la{' '}
              <span className="text-[#C9A961] font-semibold">maintenance</span> proactive et un{' '}
              <span className="text-[#C9A961] font-semibold">reporting</span> transparent.
            </p>
            <p className="text-base text-white/80 mt-6 leading-relaxed">
              Nous appliquons les normes de gestion française avec une équipe locale expérimentée et dédiée à la protection de votre patrimoine.
            </p>
          </div>

          <div className="md:col-span-3 space-y-5">
            {solutions.map((solution, index) => (
              <div
                key={index}
                className="bg-white/10 backdrop-blur-md p-6 rounded-lg border border-white/20 hover:bg-white/15 transition-all duration-300 hover:scale-105"
              >
                <div className="flex items-start space-x-6">
                  <span className="text-4xl font-thin text-[#C9A961] flex-shrink-0">
                    {solution.number}
                  </span>
                  <div>
                    <h3 className="text-xl font-semibold mb-2">{solution.title}</h3>
                    <p className="text-white/80 text-sm leading-relaxed">
                      {solution.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
